export const searchItem = (items, query) => {
    return items.filter(({ code, name }) => {
        const searchingValue = query.toLocaleLowerCase();
        const value = `${code.toLocaleLowerCase()} ${name.toLocaleLowerCase()}`;
        return value.includes(searchingValue);
    });
};
export const getComboBoxValue = (value) => {
    if (!value?.code && !value?.name) {
        return null;
    }
    return {
        code: value.code,
        name: value.name,
    };
};
